<template>
  <!-- 隐私协议 Modal -->
  <div class="modal agreement-modal" v-show="modelShowbT">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="handClose"></button>
          <h4 class="modal-title tac">高思儿童隐私协议</h4>
        </div>
        <div class="modal-body">
          <iframe width="100%" height="289" :src="agreementLinks.childrenPrivacyPolicy" frameborder="0"></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fadeAnimates from "common/fade/fadeAnimate";
import agreementLinks from "common/agreement-links";

export default {
  name: "componnetsNameb",
  props: {
    modelShowbT: Boolean,
  },
  data() {
    return { agreementLinks };
  },
  components: {
    fadeAnimates,
  },
  methods: {
    handClose() {
      this.$emit("ToggleModalbT", false);
    },
  },
  computed: {},
  mounted() {
    console.log(this.modelShow);
  },
};
</script>

<style lang='less' scoped>
@import "~style/varibles";
@import "~style/mixins";
.fwb_b_line {
  font-weight: bold;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/page/login/components/login-dealbT.vue